import { render } from "./NewClaim.vue?vue&type=template&id=4785d6f2"
import script from "./NewClaim.vue?vue&type=script&lang=js"
export * from "./NewClaim.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__